import React from 'react'
import IconBase from 'react-icon-base'

export default props => (
  <IconBase viewBox="0 0 40 40" {...props}>
    <path
      d="M33.6,25.4c0.1-0.2,0.1-0.3,0.2-0.5c0.1-0.3,0.2-0.6,0.2-0.9c0-0.1,0.1-0.3,0.1-0.4c0.1-0.3,0.1-0.7,0.2-1
      c0-0.1,0-0.3,0.1-0.4c0-0.5,0.1-0.9,0.1-1.4c0-7.9-6.4-14.4-14.4-14.4c-7.9,0-14.4,6.4-14.4,14.4c0,0.5,0,1,0.1,1.4
      c0,0.1,0,0.3,0.1,0.4c0,0.3,0.1,0.7,0.2,1C6,23.7,6,23.9,6,24c0.1,0.3,0.1,0.6,0.2,0.9c0,0.1,0.1,0.3,0.1,0.4
      c0.1,0.2,0.2,0.5,0.2,0.7c0,0,0,0,0,0.1c2.1,5.3,7.3,9,13.3,9c6,0,11.2-3.7,13.3-9c0,0,0,0,0-0.1C33.4,25.9,33.5,25.6,33.6,25.4z
      M20,33.1c-5.4,0-10-3.5-11.7-8.4c0-0.1-0.1-0.2-0.1-0.3C8.1,24.1,8,23.8,8,23.6c0-0.1-0.1-0.2-0.1-0.3c-0.1-0.3-0.1-0.6-0.1-0.9
      c0-0.1,0-0.2,0-0.3c0-0.4-0.1-0.8-0.1-1.2C7.6,14,13.2,8.4,20,8.4S32.4,14,32.4,20.8c0,0.4,0,0.8-0.1,1.2c0,0.1,0,0.2,0,0.3
      c0,0.3-0.1,0.6-0.1,0.9c0,0.1-0.1,0.2-0.1,0.3c-0.1,0.3-0.1,0.6-0.2,0.8c0,0.1-0.1,0.2-0.1,0.3C30,29.6,25.4,33.1,20,33.1z"
    />
    <path d="M20.1,14.8c0.6,0,1-0.4,1-1v-1.7c0-0.6-0.4-1-1-1s-1,0.4-1,1v1.7C19.1,14.4,19.5,14.8,20.1,14.8z" />
    <path
      d="M20,18.9c-0.1,0-0.3,0-0.4,0.1l-4.8-4.8c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4l4.8,4.8c0,0.1-0.1,0.3-0.1,0.4
      c0,1,0.9,1.9,1.9,1.9s1.9-0.9,1.9-1.9C21.9,19.7,21,18.9,20,18.9z"
    />
    <path d="M12.7,19.8H11c-0.6,0-1,0.4-1,1s0.4,1,1,1h1.8c0.6,0,1-0.4,1-1S13.3,19.8,12.7,19.8z" />
    <path d="M28.6,19.8h-1.8c-0.6,0-1,0.4-1,1s0.4,1,1,1h1.8c0.6,0,1-0.4,1-1S29.2,19.8,28.6,19.8z" />
    <path
      d="M27.4,16.2c0.4-0.4,0.4-1,0-1.4c-0.4-0.4-1-0.4-1.4,0L24.7,16c-0.4,0.4-0.4,1,0,1.4c0.2,0.2,0.5,0.3,0.7,0.3
      s0.5-0.1,0.7-0.3L27.4,16.2z"
    />
  </IconBase>
)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Icons/Dashboard.jsx